import Toastify from "toastify-js";

export default function toastify(message, className) {
    Toastify({
        text: message,
        duration: 4000,
        className: className  // "info", "warning", "success", "error"
    }).showToast();
}